﻿<script setup>
    import { useDialogPluginComponent } from 'quasar'
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
    defineEmits([...useDialogPluginComponent.emits])

    const props = defineProps({
        title: String,
        message: String,
        icon: {
            type: String,
            default: 'info'
        },
        size: String
    });
</script>

<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide" :persistent="true">
        <window :title="title" :icon="icon" :size="size">
            <template #actions>
                <btnCancel flat @click="onDialogCancel" />
                <btnOk flat @click="onDialogOK" />
            </template>
            {{message}}
        </window>
    </q-dialog>
</template>